import { render, staticRenderFns } from "./Watchlists.vue?vue&type=template&id=4d8eb46c&"
import script from "./Watchlists.vue?vue&type=script&lang=js&"
export * from "./Watchlists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d8eb46c')) {
      api.createRecord('4d8eb46c', component.options)
    } else {
      api.reload('4d8eb46c', component.options)
    }
    module.hot.accept("./Watchlists.vue?vue&type=template&id=4d8eb46c&", function () {
      api.rerender('4d8eb46c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/views/Watchlists.vue"
export default component.exports